var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcReservationOff = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-reservation-off_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 17,
  r: 17,
  fill: "#F3F4F8"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-reservation-off_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B6BAC0",
  d: "M7 21v-8c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2v2l4.55-3.28c.66-.33 1.45.15 1.45.89v8.76c0 .74-.78 1.23-1.45.89L21 18.98v2c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-reservation-off_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h34v34H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-reservation-off_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7 11h20v12H7z"
})))));
export default SvgIcReservationOff;